export default (params) => ({
  trigger: {
    name: 'content_blocks.usps.view_delivery_proposition_usp',
    params: params,
  },
  config: {
    schema: {
      content: {
        enum: [
          '1300',
          '1500',
          '1700',
          '2359',
          'other',
        ],
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'view_content',
      params: {
        sub_feature: 'cut_off_usp',
      },
    },
    nonInt: true,
  },
});
